
import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

import styles from "./Hero.module.css";


//const ParticlesBackground = dynamic(() => import("./ParticlesBackground"), { ssr: false });

const slides = [
    {
        image: "/images/advanced-medtech.webp",
        tag: "Authorized GE Healthcare Partner",
        title: "Building the Future of Healthcare Infrastructure in East Africa",
        description: "For nearly two decades, Infinity Advanced Technology Solutions has been transforming healthcare delivery across Ethiopia and East Africa through advanced medical technologies, healthcare infrasturcure development, digital health solutions, and comprehensice turkey projects.",
        cta: "Our Growth Story",
        href: "/about",
    }
];

export default function Hero() {
    const [current, setCurrent] = useState(0);
    const [prev, setPrev] = useState(-1);
    const timerRef = useRef(null);

    const goTo = (idx) => {
        const next = (idx + slides.length) % slides.length;
        setPrev(current);
        setCurrent(next);
    };

    useEffect(() => {
        timerRef.current = setTimeout(() => goTo(current + 1), 6000);
        return () => { if (timerRef.current) clearTimeout(timerRef.current); };
    }, [current]);

    const scrollDown = () => {
        window.scrollTo({ top: window.innerHeight, behavior: "smooth" });
    };

    return (
        <section className={styles.hero}>
            {/* Content */}
            <div className={styles.content}>
                <div className={styles.contentInner}>
                    <span className={styles.tag}>{slides[current].tag}</span>
                    <h1 className={styles.title} key={`title-${current}`}>
                        {slides[current].title}
                    </h1>
                    <p className={styles.desc} key={`desc-${current}`}>
                        {slides[current].description}
                    </p>
                    <div className={styles.actions}>
                        <Link to={slides[current].href} className={styles.cta}>
                            {slides[current].cta}
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14" /><path d="m12 5 7 7-7 7" /></svg>
                        </Link>
                        <Link to="/contact" className={styles.ctaSecondary}>Get in Touch</Link>
                    </div>

                    {/* Stats bar */}
                    <div className={styles.stats}>
                        {[
                            { num: "20+", label: "Years" },
                            { num: "140+", label: "Professionals" },
                            { num: "4000+", label: "Facilities" },
                            { num: "30+", label: "Partners" },
                            { num: "100+", label: "Turkey Healthcare Projects" },
                        ].map((s, i) => (
                            <div key={i} className={styles.stat}>
                                <strong className={styles.statNum}>{s.num}</strong>
                                <span className={styles.statLabel}>{s.label}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {/* Slides */}

            <div

                className={`${styles.slide} ${styles.active}`}
            >

                <img src={slides[0].image} alt={slides[0].title} className={styles.img} style={{ objectFit: "cover" }} />
                <div className={styles.overlay} />
                <p className={styles.caption}>From Blueprint to Bedside, we provide Diagnostic Imaging, Oncology & Nuclear Medicine, Cardiology Solutions, Modular ORs, Medical Gas Systems, Oxygen Plants, Infrastructure Development, and Technical Services.</p>
            </div>


            

            {/* Dot indicators */}
            <div className={styles.dots}>
                {slides.map((_, i) => (
                    <button
                        key={i}
                        className={`${styles.dot} ${i === current ? styles.dotActive : ''}`}
                        onClick={() => goTo(i)}
                        aria-label={`Slide ${i + 1}`}
                    />
                ))}
            </div>

            {/* Scroll down indicator */}
            <button className={styles.scrollDown} onClick={scrollDown} aria-label="Scroll down">
                <span className={styles.scrollText}>Scroll Down</span>
                <div className={styles.scrollMouse}>
                    <div className={styles.scrollWheel} />
                </div>
            </button>
        </section>
    );
}
